import React from 'react'
import { Pill, ChevronRightIcon } from '@ui'
import { getInitials, getAvatarStyle } from '@utils/avatar'

export function OrgNode({ node, depth = 0, expandedIds, onToggle, onSelect }) {
  const hasReports = node.reports && node.reports.length > 0
  const expanded = expandedIds.has(node.userId)

  function handleClick() {
    if (onSelect) onSelect(node)
    if (hasReports) onToggle(node.userId)
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      handleClick()
    } else if (e.key === 'Escape') {
      e.preventDefault()
      if (expanded) onToggle(node.userId, false)
    } else if (e.key === 'ArrowRight' && hasReports && !expanded) {
      e.preventDefault()
      onToggle(node.userId, true)
    } else if (e.key === 'ArrowLeft' && hasReports && expanded) {
      e.preventDefault()
      onToggle(node.userId, false)
    }
  }

  return (
    <li
      role="treeitem"
      aria-expanded={hasReports ? expanded : undefined}
      aria-level={depth + 1}
      className="org-node"
    >
      <div
        className="org-node__card"
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
      >
        <div
          className="org-node__avatar"
          style={getAvatarStyle(node.name)}
          aria-hidden="true"
        >
          {getInitials(node.name)}
        </div>

        <div className="org-node__info">
          <div className="org-node__name">{node.name || node.email}</div>
          {node.team && <div className="org-node__team">{node.team}</div>}
          <div className="org-node__pills">
            {node.sessionCount > 0 && (
              <Pill tone="success" aria-label={`${node.sessionCount} sessions`}>
                {node.sessionCount} sessions
              </Pill>
            )}
            {hasReports && (
              <Pill tone="neutral" aria-label={`${node.reports.length} direct reports`}>
                {node.reports.length} reports
              </Pill>
            )}
            {node._isOrphanRoot && (
              <Pill tone="danger" aria-label="No manager assigned">No manager</Pill>
            )}
          </div>
        </div>

        {hasReports && (
          <span className={`org-node__chevron${expanded ? ' org-node__chevron--expanded' : ''}`}>
            <ChevronRightIcon size={16} />
          </span>
        )}
      </div>

      {expanded && hasReports && (
        <ul role="group" className="org-node__children">
          {node.reports.map((child) => (
            <OrgNode
              key={child.userId}
              node={child}
              depth={depth + 1}
              expandedIds={expandedIds}
              onToggle={onToggle}
              onSelect={onSelect}
            />
          ))}
        </ul>
      )}
    </li>
  )
}
